import ImportFactory                from "./Import/ImportFactory";
import FileValidation               from "../Shared/Validation/FileValidation";
import ContactsSelectionCollection  from "./Collections/ContactsSelectionCollection";
import NotificationsController      from "../Webmail/Notifications/NotificationsController";
import ContactsCollection           from "./Collections/ContactsCollection";

export { ContactsImportController as default };

/**
* Contacts Import Controller
*
* Handler all data from file import contacts
*
* @author      brunorbarroso <bruno-b-rodrigues@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class ContactsImportController {
  /**
   * Lista de contatos para importar
   */
  contacts_list = new ContactsCollection();

  /**
   * File Import Validation Controller
   *
   * @public
   *
   * @type {FileValidation}
   *
   * @since 7.0.0
   */
  validation = new FileValidation();

  /**
   * Contacts Selection Collection
   *
   * @public
   *
   * @type {ContactsSelectionCollection}
   *
   * @since 7.0.0
   */
  contacts_selection = new ContactsSelectionCollection();

  /**
   * cria a lista de contactos para importar
   *
   * @param {string} string
   * @param {string} mime_type type file allowing to import
   *
   * @return {Boolean}
   */
  createContactsCollection(string, mime_type){
    const contacts = this.getContactsFromString(string, mime_type);

    if(!this.validation.validateCountContacts(contacts.length)){
      NotificationsController.addError('contacts.import.messages.error_max_contacts_list_add',
        [this.validation.rules_allow.count_contacts_max]);
      return false;
    }

    this.contacts_list.addItems(contacts);
    this.contacts_selection.addItems(contacts);

    return true;
  }

  /**
   * Method to read of content from file uploaded, to decode and return a array of contact object
   *
   * @param {string} string
   * @param {string} mime_type type file allowing to import
   *
   * @return {Object}
   */
  getContactsFromString(string, mime_type) {
      let decoded_content = this.getB64FromBlob(string);
          decoded_content = this.b64DecodeUnicode(decoded_content);

      return ImportFactory
          .create(decoded_content, mime_type)
          .toSapoObject();
  }

  /**
   * Set all items as selected
   *
   * @param {Array} all_contacts
   * @returns {Array}
   */
    setContactListAsSelected(all_contacts) {
      all_contacts.map(contact => this.selection.toggleSelected(contact));
  }

  /**
   * Validate file uploaded
   *
   * @param {string} type
   * @param {number} size
   * @returns {boolean}
   */
  validateFile(type, size) {
      return this.validateMimeType(type) && this.validateSize(size);
  }

  /**
   * Validate type of file
   *
   * @param {string} mime_type
   * @returns {boolean}
   */
  validateMimeType(mime_type) {
      if(!this.validation.validateMimeType(mime_type)){
        NotificationsController.addError('contacts.import.messages.error_type_file');
        return false;
      }

      return true;
  }

  /**
   * Validate size of file
   *
   * @param {number} size
   * @returns {boolean}
   */
  validateSize(size) {
      if(!this.validation.validateSize(size)){
          NotificationsController.addError('contacts.import.messages.error_max_size_file', [this.validation.rules_allow.size_max]);
          return false;
      }

      return true;
  }

  /**
   * Resets collection variables to their initial states
   *
   * @returns {void}
   */
  reset(){
    this.contacts_list.reset();
    this.contacts_selection.reset();
  }

  b64DecodeUnicode(string) {
    return decodeURIComponent(atob(string).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  }

  getB64FromBlob(string) {
    return string.substr(string.indexOf(',') + 1);
  }

  hashCode(string) {
    return btoa(encodeURIComponent(string));
  }
}